import BaseForm from '@kakadu-dev/base-frontend-helpers/forms/BaseForm';
import { DispatchSelector, StateSelector } from "../../modules/selectors";
/**
 * Faq question form
 */

export class FaqQuestionForm extends BaseForm {
  constructor(...args) {
    super(...args);
    this.fields = [{
      label: 'Категория',
      name: 'catId',
      type: BaseForm.TYPES.AUTOCOMPLETE,
      required: true,
      props: {
        common: {
          dataState: StateSelector.faq.categories.list,
          dataFetch: DispatchSelector.faq.categories.list,
          searchFilter: value => ({
            title: {
              like: `%${value}%`
            }
          }),
          valueColumn: 'id',
          labelColumn: 'title'
        }
      }
    }, {
      label: 'Вопрос',
      name: 'question',
      required: true
    }, {
      label: 'Ответ',
      name: 'answer',
      type: BaseForm.TYPES.EDITOR,
      required: true
    }, {
      label: 'Показывать голосование',
      name: 'showVoting',
      type: BaseForm.TYPES.TOGGLE,
      required: false
    }, {
      label: 'Страна',
      name: 'countries',
      required: false,
      type: BaseForm.TYPES.AUTOCOMPLETE,
      props: {
        common: {
          dataState: StateSelector.countries.list,
          dataFetch: DispatchSelector.countries.list,
          searchFilter: value => ({
            title: {
              like: `%${value}%`
            }
          }),
          valueColumn: 'id',
          labelColumn: 'title'
        }
      }
    }];
    this.dispatchCreateForm = DispatchSelector.faq.questions.create;
    this.dispatchUpdateForm = DispatchSelector.faq.questions.update;
    this.responseCreateState = StateSelector.faq.questions.create;
    this.responseUpdateState = StateSelector.faq.questions.update;
  }

}